import { useEffect } from "react";
import { APP_STORE_URL } from "@/lib/constants";

const AppStoreRedirect = () => {
  useEffect(() => {
    window.location.href = APP_STORE_URL;
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <p className="text-muted-foreground">
        Sender dig videre til App Store…{" "}
        <a href={APP_STORE_URL} className="text-primary underline">
          Klik her, hvis du ikke bliver sendt videre
        </a>
      </p>
    </div>
  );
};

export default AppStoreRedirect;
